import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import SearchBlockRHF from "../../../components/GeneralComponents/searchBlockRHF/SearchBlockRHF";
import TableComponent from "../../../components/GeneralComponents/SearchTable/tableComponent";
import ToolBlock from "../../../components/AdministrativeProcedures/commonComponents/ToolBlock/ToolBlock";

import { getDataDupShipsTicketBySearchParams } from "../../../redux/DuplicateShipsTicketReducer/actionsDuplicateShipsTicket";

import { DUPL_SHIPS_TICKET_COLUMNS } from "../../../components/GeneralComponents/SearchTable/TablesColumns";

import useChapterActionIdMatch from "../../../hooks/useChapterActionIdMatch";

import {
  options,
  setOptionsSections,
} from "../../../components/GeneralComponents/searchBlockRHF/optionsSearchBlockRHF";

import styles from "./DuplicateShipsTicket.module.css";

export default function DuplicateShipsTicket() {
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedPage, setSelectedPage] = useState(0);
  const [searchParams, setSearchParams] = useState({
    surname: "",
    name: "",
    midname: "",
    persNum: "",
    section: 0,
    status: 0,
  });
  const dispatch = useDispatch();

  const sortedMenuNames = useSelector((state) => {
    const { roleControllerReducer } = state;
    return roleControllerReducer.sortedMenuNames;
  });
  const addAccess = useChapterActionIdMatch(
    sortedMenuNames?.DUPSHIPS_TICKET?.createAnApplicationForAp?.chapterActionId,
  );
  const viewAccess = useChapterActionIdMatch(
    sortedMenuNames?.DUPSHIPS_TICKET?.viewApplication?.chapterActionId,
  );
  const editAccess = useChapterActionIdMatch(sortedMenuNames?.DUPSHIPS_TICKET?.applyForWork?.chapterActionId);
  const additionalAccess = {
    accept: useChapterActionIdMatch(
      sortedMenuNames?.DUPSHIPS_TICKET?.issueDuplicateShipTicket?.chapterActionId,
    ),
    decline: useChapterActionIdMatch(
      sortedMenuNames?.DUPSHIPS_TICKET?.refuseDuplicateShipTicket?.chapterActionId,
    ),
  };

  const dataStateDupShipsTicket = useSelector((state) => {
    const { DuplicateShipsTicketReducer } = state;
    return DuplicateShipsTicketReducer.data;
  });
  const dictionaryReducer = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer;
  });

  const handleChange = (e) => {
    if (e.target) {
      setSearchParams({
        ...searchParams,
        [e.target.dataset.id]: e.target.value,
      });
    } else {
      setSearchParams({ ...searchParams, [e.key]: e.value });
    }
  };
  const handleSearch = () => {
    setSelectedPage(0);
    dispatch(getDataDupShipsTicketBySearchParams(searchParams, 0));
    setSelectedRowData(null);
  };

  const handleClear = () => {
    setSelectedPage(0);
    setSelectedRowData(null);
    setSearchParams(
      structuredClone({
        surname: "",
        name: "",
        midname: "",
        persNum: "",
        section: 0,
        status: 0,
      }),
    );
    dispatch(
      getDataDupShipsTicketBySearchParams(
        {
          surname: "",
          name: "",
          midname: "",
          persNum: "",
          section: 0,
          status: 0,
        },
        0,
      ),
    );
  };

  useEffect(() => {
    if (dictionaryReducer.gimsSections.length > 0) {
      setOptionsSections(dictionaryReducer.gimsSections, options.inputsDuplicateShipsTicket.key);
    }
  }, [dictionaryReducer]);
  useEffect(() => {
    if (dictionaryReducer.gimsSections.length > 0) {
      setOptionsSections(dictionaryReducer.gimsSections, options.inputsDuplicateShipsTicket.key);
    }
  }, []);

  const handleRowSelect = (rowData) => {
    setSelectedRowData(rowData);
  };

  const fetchPageData = (pageIndex) => {
    setSelectedPage(pageIndex);
  };

  useMemo(() => {
    setSelectedRowData(null);
    dispatch(getDataDupShipsTicketBySearchParams(searchParams, selectedPage));
  }, [selectedPage]);

  useEffect(() => {
    fetchPageData(0);
  }, []);

  return (
    <div className={styles["content-container"]}>
      <SearchBlockRHF
        options={options.inputsDuplicateShipsTicket}
        handleChange={handleChange}
        handleSearch={handleSearch}
        handleClear={handleClear}
        searchParams={searchParams}
        externalStyles={styles}
      />
      <ToolBlock
        addBtnDis={true}
        id={selectedRowData?.id}
        appStatusId={selectedRowData?.statusId}
        editAccess={editAccess}
        viewAccess={viewAccess}
        addAccess={addAccess}
        additionalAccess={additionalAccess}
        selectedRowData={selectedRowData}
      />
      <TableComponent
        fetchData={fetchPageData}
        onRowSelect={handleRowSelect}
        columns={DUPL_SHIPS_TICKET_COLUMNS}
        data={dataStateDupShipsTicket.content || []}
        totalPages={dataStateDupShipsTicket.totalPages || 0}
        totalElements={dataStateDupShipsTicket.totalElements || 0}
        selectedPage={selectedPage}
      />
    </div>
  );
}
